(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/board.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/board.js');

'use strict';

const {
  focusElement
} = svs.numbergames.core.utils.ui;
const rulesRadio = svs.numbergames.game_model.rulesRadio;
svs.numbergames.game.views.Board = Marionette.View.extend({
  cssClass: '',
  regions: {
    numbersHeaderRegion: '#numbersHeaderRegion',
    extraNumbersHeaderRegion: '#extraNumbersHeaderRegion'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.accessibility.behaviors.KeyboardNavigation
  }],
  ui: {
    numbers: '.js-numbergames-number',
    numbersExtra: '.js-numbergames-number-extra',
    numbersBoard: '.js-numbergames-board-numbers',
    numbersExtraBoard: '.js-numbergames-board-numbers-extra'
  },
  triggers: {
    'click @ui.numbers': 'numberClicked',
    'click @ui.numbersExtra': 'numberClicked',
    'keydown @ui.numbers': {
      event: 'numberKeydown',
      preventDefault: false,
      stopPropagation: false
    },
    'keydown @ui.numbersExtra': {
      event: 'numberKeydown',
      preventDefault: false,
      stopPropagation: false
    }
  },
  modelEvents: {
    'number:added huxflux:added': 'addSelection',
    'number:removed huxflux:removed': 'removeSelection',
    'numbers:removed:all': 'render',
    'change:numbersExtraIsValid': 'markNumbersExtraAsValid',
    'change:numbersIsValid': 'markNumbersAsValid',
    'change:level': 'changedLevel',
    'change:board': 'markBoardsAsFull'
  },
  className() {
    const brandingSuffix = svs.numbergames.productMapping.getBrandingClass(this.model.get('productId'));
    return "numbergames-board\n    numbergames-board-".concat(brandingSuffix, "\n    ").concat(this.getOption('cssClass'), "\n    ").concat(this.model.has('level') && !this.model.get('level') ? 'numbergames-board-inactive' : '');
  },
  template: data => svs.numbergames.game.templates.board(data),
  templateContext() {
    return {
      rules: rulesRadio.request('rules')
    };
  },
  initialize() {
    svs.numbergames.game.logger.debug('svs.numbergames.game.views.Board initialized');
  },
  onRender() {
    this.showChildView('numbersHeaderRegion', new svs.numbergames.game.views.BoardDescription({
      tagName: 'h2',
      className: 'numbergames-board-header margin-bottom-1 padding-0 f-600',
      model: this.model,
      template(data) {
        return svs.numbergames.game.helpers.boardDescriptions.numbersBoardHeader(data);
      }
    }));
    if (this.model.has('numbersExtra')) {
      this.showChildView('extraNumbersHeaderRegion', new svs.numbergames.game.views.BoardDescription({
        tagName: 'h2',
        className: 'numbergames-extranumbers-header margin-0 padding-0 f-600',
        model: this.model,
        template(data) {
          return svs.numbergames.game.helpers.boardDescriptions.numbersExtraBoardHeader(data);
        }
      }));
    }
  },
  onBeforeAttach() {
    this.markNumbersAsValid();
    this.markNumbersExtraAsValid();
    this.markBoardsAsFull();
  },
  onNumberClicked(view, event) {
    const element = event.currentTarget;
    const isExtra = Boolean(parseInt(element.dataset.isextra, 10));
    const number = parseInt(element.dataset.number, 10);
    this.model.toggleNumber({
      number,
      isExtra,
      manual: true
    });
  },
  addSelection(board, _ref) {
    let {
      number,
      isExtra
    } = _ref;
    const numberType = isExtra ? 'numbersExtra' : 'numbers';
    const $number = this.getUI(numberType)[number - 1];
    $number.classList.add('selected');
    $number.classList.remove('un-selected');
    $number.ariaChecked = true;
  },
  removeSelection(board, _ref2) {
    let {
      number,
      isExtra
    } = _ref2;
    const numberType = isExtra ? 'numbersExtra' : 'numbers';
    const $number = this.getUI(numberType)[number - 1];
    $number.classList.remove('selected');
    $number.classList.add('un-selected');
    $number.ariaChecked = false;
  },
  markNumbersAsValid() {
    this.getUI('numbersBoard').toggleClass('numbergames-board-valid', this.model.get('numbersIsValid'));
  },
  markNumbersExtraAsValid() {
    this.getUI('numbersExtraBoard').toggleClass('numbergames-board-valid', this.model.get('numbersExtraIsValid'));
  },
  markBoardsAsFull() {
    var _this$model$get, _this$model$get2;
    this.getUI('numbersBoard').toggleClass('numbergames-board-full', Boolean((_this$model$get = this.model.get('numbers')) === null || _this$model$get === void 0 ? void 0 : _this$model$get.length) && !this.model.get('numbers').canAdd());
    this.getUI('numbersExtraBoard').toggleClass('numbergames-board-full', Boolean((_this$model$get2 = this.model.get('numbersExtra')) === null || _this$model$get2 === void 0 ? void 0 : _this$model$get2.length) && !this.model.get('numbersExtra').canAdd());
  },
  changedLevel(model, level) {
    if (level) {
      this.$el.removeClass('numbergames-board-inactive');
    } else {
      this.$el.addClass('numbergames-board-inactive');
    }
  },
  onNumberKeydown(view, event) {
    switch (event.key) {
      case ' ':
        this.triggerMethod('numberClicked', view, event);
        break;
      case 'ArrowUp':
      case 'ArrowRight':
      case 'ArrowDown':
      case 'ArrowLeft':
        this.triggerMethod('arrowKeyNavigation', event);
        break;
      default:
        return;
    }
    event.preventDefault();
    event.stopPropagation();
  },
  onArrowKeyNavigation(event) {
    let step = 0;
    switch (event.key) {
      case 'ArrowUp':
      case 'ArrowRight':
        step = 1;
        break;
      case 'ArrowDown':
      case 'ArrowLeft':
        step = -1;
        break;
      default:
    }
    const isExtra = parseInt(event.target.dataset.isextra, 10);
    const uiName = isExtra ? 'numbersExtra' : 'numbers';
    const numbers = this.getUI(uiName);
    const index = numbers.index(event.target) + step;
    if (index < 0) {
      focusElement(numbers.last());
    } else if (index >= numbers.length) {
      focusElement(numbers.first());
    } else {
      focusElement(numbers[index]);
    }
  },
  onActivateTabNavigation(event) {
    const isExtra = Boolean(parseInt(event.target.dataset.isextra, 10));
    const numbers = isExtra ? this.getUI('numbersExtra') : this.getUI('numbers');
    if (numbers) {
      numbers.attr('tabindex', 0);
      focusElement(numbers.first());
    }
  },
  onInactivateTabNavigation(event) {
    let numbers;
    let board;
    if (parseInt(event.target.dataset.isextra, 10)) {
      numbers = this.getUI('numbersExtra');
      board = this.getUI('numbersExtraBoard');
    } else {
      numbers = this.getUI('numbers');
      board = this.getUI('numbersBoard');
    }
    if (numbers) {
      numbers.attr('tabindex', -1);
    }
    if (board) {
      focusElement(board);
    }
  }
});

 })(window);